import { Dialog, DialogTitle, DialogActions, Button, Typography, DialogContent } from '@mui/material';

export default function ConfirmDialog ({ open, onClose, onConfirm, title }) {
  return (
    <Dialog open={open} onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            borderRadius: 2,
          },
        }
      }}
    >
      <DialogTitle>Confirm Delete</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to delete
           <strong> {title} </strong>
          from the lead list?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">Cancel</Button>
        <Button onClick={onConfirm} color="error" variant="contained">Delete</Button>
      </DialogActions>
    </Dialog>
  );
}
